module.exports = __webpack_public_path__ + "static/img/wemImg2.1fcae4ef.png";